import type { jsPDF } from "jspdf";
import { Box } from "../layout/box.ts";
import { BaseElement } from "./baseElement.ts";

export class GridContainer extends BaseElement {
	kind = "grid" as const;
	columns: number;
	gapX: number;
	gapY: number;

	constructor(box: Box, id: string, columns = 2, gapX = 0, gapY = 0) {
		super(box, id);
		this.columns = columns;
		this.gapX = gapX;
		this.gapY = gapY;
	}

	async calculate(jsPdf: jsPDF) {
		const boundingBox = this.box.getBoundingBox();
		let rowHeight = 0;
		let cursorY = boundingBox.y;
		let totalHeight = 0;
		let index = 0;
		for (const child of this.children) {
			const columnIndex = index % this.columns;
			const colWidth = (boundingBox.width - (this.columns - 1) * this.gapX) / this.columns;
			const colWidthWithSpan = child.colSpan * colWidth + (child.colSpan - 1) * this.gapX;
			const x = columnIndex * (colWidthWithSpan + this.gapX);
			child.box.position.x = boundingBox.x + x;
			child.box.position.y = cursorY;
			child.box.size.width = colWidthWithSpan;
			await child.calculate(jsPdf);
			const childBoundingBox = child.box.getBoundingBox();
			rowHeight = Math.max(rowHeight, childBoundingBox.outerHeight);

			index += child.colSpan;

			if (index % this.columns == 0) {
				cursorY += rowHeight + this.gapY;
				totalHeight += rowHeight + this.gapY;
				rowHeight = 0;
			}
		}
		totalHeight -= this.gapY; // Remove last gap
		this.box.size.height = totalHeight;
	}

	override async draw(pdfDocument: jsPDF): Promise<void> {
		for (const child of this.children) {
			await child.draw(pdfDocument);
		}
	}
}
